angular
    .module('backOffice')
    .controller('messageCenterComposeModalController', messageCenterComposeModalController);

messageCenterComposeModalController.$inject = [
    '$scope',
    '$modalInstance',
    'modalService',
    'companiesService',
    'messagingCenterService',
    'uiMessages',
    'entitlementsService',
];

function messageCenterComposeModalController(
    $scope,
    $modalInstance,
    modalService,
    companiesService,
    messagingCenterService,
    uiMessages,
    entitlementsService
) {
    $scope.selectedUser = {
        object: null,
    };
    $scope.message = {
        files: [],
    };
    $scope.allowedExtensions = entitlementsService.hasEntitlement(
        'Feature.MessageCenter.CreateSaveMessage'
    )
        ? [
              '.csv',
              '.doc',
              '.docx',
              '.gif',
              '.jfif',
              '.jif',
              '.jpg',
              '.jpeg',
              '.jpe',
              '.pdf',
              '.png',
              '.txt',
              '.xls',
              '.xlsx',
          ]
        : ['.csv', '.doc', '.docx', '.gif', '.jpg', '.jpeg', '.pdf', '.png', '.txt'];

    $scope.validationOptions = {
        maxFileSize: 3145728,
        allowedExtensions: $scope.allowedExtensions,
    };

    $scope.$watch('message.companyId', () => {
        if ($scope.message.companyId) {
            getCompanyUsers();
        } else {
            $scope.message.userId = null;
            $scope.users = [];
        }
    });

    $scope.onSelectFile = function (e) {
        if (e.files) {
            angular.forEach(e.files, file => {
                if (
                    $.inArray(
                        file.extension.toLowerCase(),
                        $scope.validationOptions.allowedExtensions
                    ) === -1
                ) {
                    modalService.showModal(
                        {},
                        {
                            bodyTitle: 'File Error',
                            alertType: 'Error',
                            isAlert: true,
                            summaryText: uiMessages.FileWrongExtension,
                        }
                    );
                    e.preventDefault();
                }
                // File size is not available in all browsers
                else if (file.size > $scope.validationOptions.maxFileSize) {
                    modalService.showModal(
                        {},
                        {
                            bodyTitle: 'File Error',
                            alertType: 'Error',
                            isAlert: true,
                            summaryText: uiMessages.DocExceedsMaxSize,
                        }
                    );
                    e.preventDefault();
                }
            });

            $scope.form.$setDirty();
            angular.forEach(e.files, file => {
                $scope.message.files.push({ uid: file.uid, rawFile: file.rawFile });
            });
            $scope.$apply();
        }
    };

    $scope.onRemoveFile = function (e) {
        if (e.files) {
            $scope.form.$setDirty();
            angular.forEach(e.files, file => {
                $scope.message.files = $scope.message.files.filter(el => el.uid !== file.uid);
            });
            $scope.$apply();
        }
    };

    $scope.cancel = function () {
        if ($scope.form.$dirty) {
            var confirmCancel = modalService.showModal(
                {},
                {
                    closeButtonText: 'Continue Editing',
                    actionButtonText: 'OK',
                    headerText: 'Cancel',
                    bodyText: uiMessages.CancelSendMessage,
                    submit() {
                        confirmCancel.close();
                        $modalInstance.close();
                    },
                }
            );
        } else {
            $modalInstance.close();
        }
    };

    $scope.send = function () {
        messagingCenterService.saveMessage($scope.message).then(response => {
            $scope.message = response;
            $modalInstance.close($scope.message);
        });
    };

    function init() {
        getCompanies();
        getMessageCategories();
    }

    function getCompanies() {
        companiesService.getCompaniesByFI().then(response => {
            $scope.companies = angular.copy(response);
        });
    }

    function getCompanyUsers() {
        companiesService.getEnrolledUsers($scope.message.companyId).then(response => {
            $scope.users = angular.copy(response);
        });
    }

    function getMessageCategories() {
        messagingCenterService.getMessageCategories().then(response => {
            $scope.categories = angular.copy(response);
        });
    }

    $scope.setForm = function (form) {
        $scope.form = form;
    };

    init();
}
